var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.pageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "form",
            {
              attrs: {
                id: "categorieForm",
                method: "POST",
                enctype: "multipart/form-data"
              }
            },
            [
              _c("div", { staticClass: "forms-container" }, [
                _c(
                  "div",
                  { staticClass: "row no-margin" },
                  [
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                name: "categoryId",
                                id: "categoryId",
                                label: "text",
                                filterable: false,
                                options: _vm.categoryArr,
                                placeholder: "Select Parent Category"
                              },
                              on: {
                                change: _vm.changedValue,
                                input: function($event) {
                                  return _vm.changedCategoryFor()
                                },
                                search: _vm.onSearchCategory
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _c("div", { staticClass: "d-center" }, [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(option.text) +
                                            "\n                                        "
                                        )
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "selected-option",
                                  fn: function(option) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "selected d-center" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(option.text) +
                                              "\n                                        "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.categoryId,
                                callback: function($$v) {
                                  _vm.categoryId = $$v
                                },
                                expression: "categoryId"
                              }
                            },
                            [
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  "\n                                        Search Category...\n                                    "
                                )
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.categoryIdErrors))
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9 paddingleft0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mediaSource,
                              expression: "mediaSource"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            maxlength: "190",
                            type: "text",
                            id: "mediaSource",
                            name: "mediaSource",
                            placeholder: "Enter Media Source"
                          },
                          domProps: { value: _vm.mediaSource },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.mediaSource = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 forms-block" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9 paddingleft0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mediaCaption,
                              expression: "mediaCaption"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            maxlength: "190",
                            type: "text",
                            id: "mediaCaption",
                            name: "mediaCaption",
                            placeholder: "Enter Media Caption"
                          },
                          domProps: { value: _vm.mediaCaption },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.mediaCaption = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.slug == "video"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            },
                            [
                              _c("span", { attrs: { id: "myForm" } }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.picked,
                                        expression: "picked"
                                      }
                                    ],
                                    attrs: {
                                      id: "uploadManually",
                                      type: "radio",
                                      name: "cars",
                                      value: "1",
                                      checked: "checked"
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.picked, "1")
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.picked = "1"
                                      }
                                    }
                                  }),
                                  _vm._v("Enter Manually")
                                ]),
                                _vm._v(" "),
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.picked,
                                        expression: "picked"
                                      }
                                    ],
                                    attrs: {
                                      id: "vodepUrl",
                                      type: "radio",
                                      name: "cars",
                                      value: "2"
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.picked, "2")
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.picked = "2"
                                      }
                                    }
                                  }),
                                  _vm._v("Enter Video URL")
                                ])
                              ])
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isHideDropZone
                      ? _c("div", { staticClass: "col-12 forms-block" }, [
                          _vm._m(3),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 paddingleft0" },
                            [
                              _c("vue-dropzone", {
                                ref: "dropzone",
                                attrs: {
                                  id: "drop1",
                                  options: _vm.dropzoneOptions,
                                  destroyDropzone: false,
                                  headers: _vm.dropzoneOptions.headers,
                                  name: "file"
                                },
                                on: {
                                  "vdropzone-removed-file":
                                    _vm.removedSelectedFile,
                                  "vdropzone-success": _vm.vfileSuccess,
                                  "vdropzone-duplicate-file":
                                    _vm.vduplicateFile,
                                  "vdropzone-mounted": _vm.fileAdd,
                                  "vdropzone-file-added": _vm.fileAdd,
                                  "vdropzone-total-upload-progress":
                                    _vm.progressOfUload
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "requiredstar" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.cropError))
                              ])
                            ],
                            1
                          )
                        ])
                      : _c("div", { staticClass: "col-12 forms-block" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 paddingleft0" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.mediaURL,
                                    expression: "mediaURL"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  maxlength: "190",
                                  type: "text",
                                  id: "mediaURL",
                                  name: "mediaURL",
                                  placeholder: "Video URL"
                                },
                                domProps: { value: _vm.mediaURL },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.mediaURL = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "requiredstar" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.mediaURLError))
                              ])
                            ],
                            1
                          )
                        ]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "col-12 paddingleft0" }, [
                        _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            id: "addMedia",
                            type: "submit",
                            value: "Save"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.saveMediaDetail()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeAllFiles()
                              }
                            }
                          },
                          [_vm._v("Remove File")]
                        )
                      ])
                    ])
                  ],
                  2
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "categories" } }, [
        _vm._v("Category :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "mediaSource" } }, [
        _vm._v("Media Source :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "mediaCaption" } }, [
        _vm._v("Media Caption :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "mediaCaption" } }, [
        _vm._v("Media File :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "mediaURL" } }, [
        _vm._v("Video URL :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c("div", { staticClass: "alert", attrs: { id: "alertError" } }, [
          _c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74918aaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74918aaa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/gallery/AddMedia.vue
// module id = null
// module chunks = 